"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useNavigate } from "@/lib/navigation";

const Logo = () => {
  const pathname = usePathname();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    // If we're already on the homepage, do a smooth refresh
    if (pathname === "/") {
      e.preventDefault();
      // Use router to trigger a refresh
      navigate("/", { replace: true });
      // Trigger a manual refresh event for components that listen for it
      window.dispatchEvent(new Event("refresh"));
    }
    // Otherwise, let the Link component handle the navigation
  };

  return (
    <Link
      href="/"
      onClick={handleClick}
      className="flex items-center justify-center hover:opacity-90 transition-opacity"
    >
      <img src="/logo.svg" alt="World Class Design" width={116} height={40} className="h-10 w-auto" />
    </Link>
  );
};

export default Logo;
